export default function pickPackageByProduct (product, availablePackage): string[] {

  return availablePackage.map(objProdPack => {
    if (objProdPack.product === product) {
      return objProdPack.packages;
    }
  }).filter(item => item)[0] || [];

}
